export enum ContentSharingTypesEnum {
    twitter,
    facebook,
    linkedin,
    email
}
